// extracted by css-extract-rspack-plugin
export default {"trigger":"aWM8D","label":"L7SeP","dropdown":"LOSjG"};